import { get, post, post_query } from "@/axios";

/**
 * 配置
 * **/
// 仓库配置
//仓库列表
export const warehouseList = function () {
  return get("/wms/warehouse/warehouseList");
};

//修改仓库
export const editWarehouse = function (params) {
  return post("/wms/warehouse/updWarehouse", params);
};

//新增仓库
export const createWarehouse = function (params) {
  return post("/wms/warehouse/createWarehouse", params);
};

//<<<<<<<<<<<<<<<<<<<<<箱子<<<<<<<<<<<<<<<<<<<<<<<<
// 箱子模板分页
export const boxTemplatePage = function (params) {
  return get("/wms/box/page", params);
};
// 箱子模板 新增
export const addBox = function (params) {
  return post("/wms/box/add", params);
};
// 箱子模板 批量新增
export const batchAddBox = function (params) {
  return post("/wms/basket/batchAdd", params);
};
// 箱子模板 编辑
export const editBox = function (params) {
  return post("/wms/box/edit", params);
};
// 箱子模板 删除
export const delBox = function (params) {
  return post("/wms/box/remove", params);
};

//<<<<<<<<<<<<<<<<<<<<<分拣篮配置<<<<<<<<<<<<<<<<<<<<<<<<
// 分拣篮配置
export const basketPageGet = function (params) {
  // return post('mock/login', params)
  return get("/wms/basket/page", params);
};
export const setBasket = function (params) {
  return post("/wms/basket/edit", params);
};
export const basketDel = function (params) {
  // return post('mock/login', params)
  return post("/wms/basket/del", params);
};

//<<<<<<<<<<<<<<<<<<<<<库区配置<<<<<<<<<<<<<<<<<<<<<<<<
// 库区列表
export const getRegionList = function (params) {
  return get("/wms/region/RegionList", params);
};
//新建库区
export const createRegin = function (params) {
  return post("/wms/region/createRegion", params);
};
//修改库区
export const updRegin = function (params) {
  return post("/wms/region/updRegion", params);
};

//<<<<<<<<<<<<<<<<<<<<<库位配置<<<<<<<<<<<<<<<<<<<<<<<<
//库位分页查询
export const gridPageList = function (params) {
  return post("/wms/grid/gridPage", params);
};
//批量保存
export const gridSave = function (params) {
  return post("/wms/grid/saveGrids", params);
};

//<<<<<<<<<<<<<<<<<<<<<发货重量配置<<<<<<<<<<<<<<<<<<<<<<<<
//发货重量分页查询
export const weightCostConfigList = function (params) {
  return post("/wms/weightCostConfig/page", params);
};
//查询所有货代公司
export const forwarderList = function (params) {
  return get("/settlement/intForwarderConfig/getForwarderList", params);
};
//新增配置
export const addConfig = function (params) {
  return post("/wms/weightCostConfig/add", params);
};
//编辑
export const editConfig = function (params) {
  return post("/wms/weightCostConfig/edit", params);
};

//<<<<<<<<<<<<<<<<<<<<<打印标签模板<<<<<<<<<<<<<<<<<<<<<<<<

//列表
export const printList = function (params) {
  return get("/wms/print/list", params);
};
//保存
export const savePrint = function (params) {
  return post("/wms/print/save", params);
};

//<<<<<<<<<<<<<<<<<<<<<物流API关联<<<<<<<<<<<<<<<<<<<<<<<<

//分页
export const getLogistics = function (params) {
  return post("/wms/logisticsApiConfig/page", params);
};
//保存
export const saveLogistics = function (params) {
  return post("/wms/logisticsApiConfig/save", params);
};
/**
 * 获取渠道
 * **/

export const getChannel = function (params) {
  return get("/wms/delivery/task/getChannel", params);
};

//<<<<<<<<<<<<<<<<<<<<<默认标签配置<<<<<<<<<<<<<<<<<<<<<<<<
/**
 * 查询分页默认标签配置
 * **/

export const defaultLabelPage = function (params) {
  return post("/wms/defaultLabelConfig/page", params);
};

//获取打印标签模板
export const printListByType = function (params) {
  return get("/wms/print/listByType", params);
};

//编辑默认标签模版
export const editDefaultTemplate = function (params) {
  return post("/wms/defaultLabelConfig/editTemplate", params);
};

//获取面单-打印机配置
export const sheetConfig = function (params) {
  return get("/wms/printConfig/getLogisticPrintConfig", params);
};

//打印机配置
export const printConfigPage = function (params) {
  return post("/wms/printConfig/page", params);
};

//创建打印机配置
export const createPrintConfig = function (params) {
  return post("/wms/printConfig/create", params);
};

//编辑打印机配置
export const editPrintConfig = function (params) {
  return post("/wms/printConfig/editPrint", params);
};

//开启/关闭打印机配置
export const editOpenOrClose = function (params) {
  return get("/wms/printConfig/editOpenOrClose", params);
};

//<<<<<<<<<<<<<<<<<<<<<容器<<<<<<<<<<<<<<<<<<<<<<<<
//分页
export const containerPage = function (params) {
  return post("wms/container/page", params);
};

//创建容器
export const containerCreate = function (params) {
  return post("/wms/container/create", params);
};

//容器关闭
export const containerClose = function (params) {
  return post_query("/wms/container/close", params);
};

//容器开启
export const containerOpen = function (params) {
  return post_query("/wms/container/open", params);
};

//容器商品
export const containerProducts = function (params) {
  return post("/wms/container/products", params);
};

//子容器
export const getChildContainers = function (params) {
  return get("/wms/container/getChildContainers", params);
};

//物流api批量编辑
export const logisticsApiConfigBatchEdit = function (params) {
  return post("/wms/logisticsApiConfig/batchEdit", params);
};
